import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { ArrowRightLeft, Lock } from 'lucide-react';

export interface Transferencia {
  id: string;
  ticketId: string;
  dataCriacao: string;
  mensagemInterna?: string | null;
  autor?: { id: string; nome: string } | null;
  destinoUsuario?: { id: string; nome: string | null } | null;
  destinoFila?: { id: string; nome: string | null } | null;
}

// Registro de transferência do ticket exibido no meio da conversa (o cliente não vê)
const TransferenciaEvento: React.FC<{ transferencia: Transferencia }> = ({ transferencia }) => {
  const { t } = useTranslation();
  const { autor, destinoUsuario, destinoFila, mensagemInterna } = transferencia;

  const destino = destinoUsuario
    ? destinoUsuario.nome || t('atendimento.unknown')
    : destinoFila
      ? `${t('atendimento.transferEventQueue')} ${destinoFila.nome || t('atendimento.unknown')}`
      : t('atendimento.unknown');

  return (
    <div className="flex justify-center my-3">
      <div className="w-full max-w-[85%] md:max-w-[70%] rounded-lg border border-violet-300 border-l-4 border-l-violet-500 bg-violet-50 px-3 py-2 shadow-sm dark:border-violet-700 dark:border-l-violet-400 dark:bg-violet-950/60">
        <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-violet-800 dark:text-violet-200">
            <ArrowRightLeft size={14} />
            {t('atendimento.transferEventTitle')}
          </span>
          <span className="text-[11px] text-violet-700/80 dark:text-violet-300/80">
            {format(new Date(transferencia.dataCriacao), 'dd/MM/yyyy HH:mm')}
          </span>
        </div>

        <p className="mt-1 text-xs text-gray-700 dark:text-gray-200">
          <span className="text-gray-500 dark:text-gray-400">{t('atendimento.transferEventFrom')}</span>{' '}
          <strong>{autor?.nome || t('atendimento.unknown')}</strong>
          {'  →  '}
          <span className="text-gray-500 dark:text-gray-400">{t('atendimento.transferEventTo')}</span>{' '}
          <strong>{destino}</strong>
        </p>

        {mensagemInterna && (
          <div className="mt-2 rounded-md bg-white/80 px-2.5 py-2 dark:bg-slate-800/70">
            <span className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-violet-700 dark:text-violet-300">
              <Lock size={11} />
              {t('atendimento.internalMessage')}
            </span>
            <p className="mt-1 whitespace-pre-wrap break-words text-sm text-gray-800 dark:text-gray-100">
              {mensagemInterna}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransferenciaEvento;
